(() => {
  if (window.snrsCollectionQuickAdd) return;
  window.snrsCollectionQuickAdd = true;
  document.addEventListener('click', event => {
    const overlay = event.target.closest('.snrs-card-quick-add');
    if (overlay) event.stopPropagation();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const overlay = event.target.closest('.snrs-card-quick-add[open]');
    if (overlay) {
      overlay.open = false;
      overlay.querySelector('summary').focus();
    }
  });
  document.addEventListener('variant:add', () => {
    document.querySelectorAll('.snrs-card-quick-add[open]').forEach(overlay => { overlay.open = false; });
  });
})();
